import React from "react";
import PropTypes from "prop-types";

const ProgressBar = ({ max, min, current, width, height }) => {
  const getFillPercentage = () => {
    const range = max - min;
    const value = current - min;
    const result = (value / range) * 100;
    return (result > 100 ? 100 : result) || 0;
  };

  return (
    <div
      className="progress_bar"
      style={{
        height,
        width,
      }}
      data-testid="vt-progress-bar"
    >
      <div
        className="progress_bar__fill_bar"
        style={{
          width: `${getFillPercentage()}%`,
        }}
      />
    </div>
  );
};

export default ProgressBar;

ProgressBar.defaultProps = {
  min: 0,
  width: "50px",
  height: "5px",
};

ProgressBar.propTypes = {
  max: PropTypes.number.isRequired,
  min: PropTypes.number,
  current: PropTypes.number.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};
